var _defineProperty = require("/codebuild/output/src4172266550/src/jag-website/node_modules/@babel/runtime/helpers/defineProperty.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var _ = require('lodash');
var extractGridAreaNames = require('./util/extractGridAreaNames');
module.exports = function (_ref) {
  var addUtilities = _ref.addUtilities,
    matchUtilities = _ref.matchUtilities,
    theme = _ref.theme,
    variants = _ref.variants;
  var gridAreaNames = extractGridAreaNames(theme('gridTemplateAreas'));
  var templateAreas = _.reduce(theme('gridTemplateAreas'), function (templates, area, name) {
    return _objectSpread(_objectSpread({}, templates), {}, _defineProperty({}, ".grid-areas-".concat(name), {
      'grid-template-areas': area.map(function (row) {
        return "\"".concat(row, "\"");
      }).join('\n')
    }));
  }, {});
  addUtilities([templateAreas], variants('gridTemplateAreas'));
  var namedAreas = gridAreaNames.reduce(function (areas, name) {
    return _objectSpread(_objectSpread({}, areas), {}, _defineProperty({}, ".grid-in-".concat(name), {
      'grid-area': name
    }));
  }, {});
  addUtilities([namedAreas], []);
  var namedLines = gridAreaNames.reduce(function (lines, name) {
    var _objectSpread4;
    return _objectSpread(_objectSpread({}, lines), {}, (_objectSpread4 = {}, _defineProperty(_objectSpread4, ".row-start-".concat(name), {
      'grid-row-start': "".concat(name, "-start")
    }), _defineProperty(_objectSpread4, ".row-end-".concat(name), {
      'grid-row-end': "".concat(name, "-end")
    }), _defineProperty(_objectSpread4, ".col-start-".concat(name), {
      'grid-column-start': "".concat(name, "-start")
    }), _defineProperty(_objectSpread4, ".col-end-".concat(name), {
      'grid-column-end': "".concat(name, "-end")
    }), _objectSpread4));
  }, {});
  addUtilities([namedLines], []);

  // allow arbitrary values
  matchUtilities({
    'grid-areas': function gridAreas(value) {
      value = "\"".concat(value, "\"");
      value = value.replace(/ *, */g, '" "');
      return {
        'grid-template-areas': "".concat(value)
      };
    },
    'grid-in': function gridIn(value) {
      return {
        'grid-area': "".concat(value)
      };
    }
  });
};